/**
 * Синхронизация UserKey с Tenderplan (POST /api/keys/sync/).
 */

export async function syncUserKeys(api) {
  const { data } = await api.post('/keys/sync/')
  return data
}

let _lastSyncAt = 0
const SYNC_DEBOUNCE_MS = 3000

/** Не чаще раза в 3 с — для выбора ключа в списке. */
export async function syncUserKeysDebounced(api) {
  const now = Date.now()
  if (now - _lastSyncAt < SYNC_DEBOUNCE_MS) return null
  _lastSyncAt = now
  return syncUserKeys(api)
}

/**
 * Сохраняет выбранный ключ в localStorage, если primary на позиции 0 в Tenderplan.
 */
export function applyKeySyncToStorage(userId, syncResult) {
  if (userId == null || userId === '') return
  const keyId = syncResult?.primary_tp_key_id
  if (!keyId || syncResult?.primary_tp_index !== 0) return
  try {
    localStorage.setItem(`selected_key_${userId}`, String(keyId))
  } catch (_) {}
}

export function formatKeyOwners(owners) {
  if (!Array.isArray(owners) || !owners.length) return 'без владельца'
  return owners.map((o) => o.email || `#${o.user_id}`).filter(Boolean).join(', ')
}
